import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Editor } from "../editor/Editor";
import { useEffect, useRef, useState } from "react";
import CmsService from "../../../service/CmsService";
import CatService from "../../../service/CatService";
import { useNavigate, useParams,useSearchParams } from "react-router-dom";
import { Messages } from "primereact/messages";
import { GrpBasic } from "./GrpBasic";
import { ButtonMenu } from "../../common/ButtonMenu";
import { SelectButton } from "primereact/selectbutton";
import { useTranslation } from "react-i18next";

export function GrpEditPageUpdate({id})
{
    let params = useParams();
    id = params.id;
    const [grp,setGrp] = useState(null);

    useEffect(()=>{
    },[]);
    useEffect(()=>{
        setGrp(null);
        CmsService.getGrp(id).then((ret)=>{
            console.log('grp:'+JSON.stringify(ret));
            setGrp(ret);
        })
    },[id]);

    return (grp!=null?<GrpEditPage group={grp}/>:<></>)
}
export function GrpEditPageNew({courseId})
{
    let params = useParams();
    courseId = params.courseId;

    var grp={name:'',catId:courseId};
    return <GrpEditPage group={grp} courseId={courseId}/>;
}
export function GrpEditPage({group,courseId})
{
    const {t}=useTranslation();
    let navigate = useNavigate();
    //TODO find wrt contentType and format
    const dtid = group.dats!=undefined && group.dats.length>0?group.dats[0].id:null;
    const contentTypes=[{label:'Group',value:'BODY'}];
    console.log("GrpEditPage:courseId:"+courseId+" grp.id:"+group.id);
    const addQuestionItems=(node)=>{return [
        {label: t('QuestionType.MC'),command:()=>addQuestion('MC')},
        {label: t('QuestionType.MR'),command:()=>addQuestion('MR')},
        {label: t('QuestionType.TF'),command:()=>addQuestion('TF')},
        {label: t('QuestionType.YN'),command:()=>addQuestion('YN')},
        {label: t('QuestionType.OE'),command:()=>addQuestion('OE')},
        {label: t('QuestionType.FIB'),command:()=>addQuestion('FIB')},
        {label: t('QuestionType.MATCH'),command:()=>addQuestion('MATCH')},
        {label: t('QuestionType.GRP'),command:()=>addQuestion('GRP')}, 
        {label: t('QuestionType.INT'),command:()=>addQuestion('INT')},        
    ]};

    const [sessionId,setSessionId] = useState('');
    const [grp,setGrp]=useState(group);
    const [datId,setDatId]=useState(dtid);
    const [modified,setModified]=useState(true);

    const editor = useRef(null);
    const messages = useRef([]);

    const addQuestion=(itemType)=>{
        navigate('/itembank/addquetogrp/'+grp.id+'?questionType='+itemType);
    }
    const toolBarStart=()=>{
        return( 
        <>
            <Button severity="secondary" label="New Group"/>
            {grp.id>0?
            <>
            <div className="ml-2 font-bold">{t('Question_Group_ID') +':'+ grp.id}</div>
            <ButtonMenu label={t('Add_Question')} items={addQuestionItems}></ButtonMenu>
            </>:''
            }
        </>
        )
    }
    const onGrpNavChange=(e)=>{

        if(e.target.value == 'Group') //group header
            navigate('/itembank/grp/'+grp.id);
        else
        {
            var qid = grp.qids[parseInt(e.target.value)-1];
            navigate('/itembank/question/'+qid);
        }
    }
    const groupNavigator=()=>{
        if(grp == undefined)
            return '';
        var items=[];
        items.push('Group');
        if(grp.qids)
        {
            grp.qids.forEach((item,index)=>{
                items.push(index+1);
            });    
        }
        return(
            items.length>1?
            <SelectButton className="mr-4" value={'Group'} onChange={onGrpNavChange} options={items} />:<></>
        );
    }
    const toolBarEnd=()=>{
        return(
            <>
                {groupNavigator()}
                <Button severity="primary" icon="pi pi-save" label={t('Save')} onClick={onSave} disabled={!modified}></Button>
            </>
        )
    }
    const onSave=()=>{
        if(!checkValues())
            return;
        editor.current.save(grp.id,'BODY').then((saveInfos)=>{
            var datsSaved=[];
            var sessions=[];
            var fields=[];
            var mediaLinks=[];
            saveInfos.forEach((si)=>{
                datsSaved=datsSaved.concat(si.dats);
                sessions.push(si.sessionId);
                fields=fields.concat(si.fields);
                mediaLinks=mediaLinks.concat(si.mediaLinks);
            });

            var grpDto={...grp,sessions:sessions,mediaLinks:mediaLinks};
            if(grp.id == undefined)
            {
                CmsService.createGrp(grpDto).then((ret)=>{
                    console.log("saved:"+JSON.stringify(ret));
                    setGrp(ret); 
                    setModified(false);
                }).catch((error)=>{
                    showError(error.response.data?error.response.data.message:error.message);
                });
            }
            else
            {
                CmsService.updateGrp(grp.id,grpDto).then((ret)=>{
                    console.log("saved:"+JSON.stringify(ret));
                    setGrp(ret); 
                    setModified(false);
                }).catch((error)=>{
                    showError(error.response.data?error.response.data.message:error.message);
                });
            }
        })
    };
    const checkValues=()=>{
        if(grp.name == undefined || grp.name.trim().length == 0)
        {
            showError("Name_is_empty");
            return false;    
        }
        return true;
    };
    const onBasicChange=(q)=>{
        var qu={...grp,...q};
        setGrp(qu);
        setModified(true);
    }
    const onDocumentModified=()=>{
        if(!modified)
            setModified(true);
    } 
	const showError = (err) => {
		messages.current.show({ severity: 'error', summary: this.props.t('error'), detail: this.props.t("@error."+err)});
	}	
    return(
        <Card className="col-12 xl:col-8">
         <Toolbar start={toolBarStart} end={toolBarEnd}/>
         <Messages ref={messages}></Messages>         
         <TabView className="mt-2" renderActiveOnly={false}>
            <TabPanel header={t('Question_Group')}>                
                <GrpBasic grp={grp} courseId={courseId} onChange={onBasicChange}></GrpBasic>
            </TabPanel>
         </TabView>
         <Editor ref={editor} dats={grp.dats} options={0} onModified={onDocumentModified} ctypes={contentTypes} mode="group"></Editor>
        </Card>
    )
}